import { React, useState, useEffect } from "react";
import { API_URL } from "../../shared/constant";
import { toast, ToastContainer } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const Unauthorized = () => {

    const navigate = useNavigate();
    
    const movedTo = () => {
        const access_token = sessionStorage.getItem("access_token");
        const my_id = sessionStorage.getItem("my_id");
        if (access_token && my_id) {
          if (my_id == "1000") {
            navigate("/dashboard", { replace: true });
          } else if (my_id == "100") {
            navigate("/master-dashboard", { replace: true });
          } else {
            sessionStorage.clear();
            navigate("/", { replace: true });
          }
        }
    }

    return (
        <>
            <main>
                <div className="container">
                <div className="form-side">
                    <div className="text-center">
                        <span className="logo-single">
                            <img src={"/assets/img/logo.png"} className="img-fluid logo" alt="1" />
                        </span>
                    </div>
                    <div className="text-center">

                        <h6 className="mb-4">Ooops... looks like an error occurred!</h6>
                        <p className="mb-0 text-muted text-small mb-0">Error code</p>
                        <p className="display-1 font-weight-bold mb-5">
                            404
                        </p>
                        <button onClick={movedTo} type="button" className="btn btn-primary btn-lg btn-shadow">GO BACK HOME</button>
                    </div>
                </div>
                </div>
            </main>
        </>
    );
};
export default Unauthorized;
